import React, { useState } from 'react';
import { Settings as SettingsIcon, Menu, ListChecks } from 'lucide-react';
import { Sidebar } from '../components/Sidebar';
import { auth } from '../lib/firebase';
import { Card, CardHeader, CardContent } from '../components/ui/card';
import { Label } from '../components/ui/label';
import { Switch } from '../components/ui/switch';
import { useStore } from '../lib/store';

export function Settings() {
  const [menuOpen, setMenuOpen] = useState(true);
  const { deleteOnlyMode, setDeleteOnlyMode } = useStore();

  return (
    <div className="flex min-h-screen bg-background">
      <Sidebar
        user={auth.currentUser}
        isOpen={menuOpen}
        onClose={() => setMenuOpen(false)}
      />

      <button
        onClick={() => setMenuOpen(true)}
        className={`fixed top-4 left-4 z-20 p-2 text-white rounded-lg bg-[#26428C] ${menuOpen ? 'hidden' : 'block'}`}
      >
        <Menu className="w-6 h-6" />
      </button>

      <div className={`flex-1 transition-all duration-200 ${menuOpen ? 'ml-64' : 'ml-0'}`}>
        <div className="max-w-4xl mx-auto px-4 py-8">
          <div className="flex items-center gap-3 mb-8">
            <SettingsIcon className="w-8 h-8 text-primary" />
            <h1 className="text-3xl font-bold">Configurações</h1>
          </div>

          <div className="space-y-6">
            {/* Seção de Listas */}
            <Card>
              <CardHeader>
                <div className="flex items-center gap-2">
                  <ListChecks className="w-5 h-5 text-primary" />
                  <h2 className="text-xl font-semibold">Listas</h2>
                </div>
              </CardHeader>
              <CardContent>
                <div className="space-y-6">
                  <div className="flex items-center justify-between">
                    <div className="space-y-1">
                      <Label>Modo de exclusão simples</Label>
                      <p className="text-sm text-muted-foreground">
                        Quando ativado, o botão "Resolver" apenas remove o registro da lista de falhas, 
                        sem movê-lo para a lista de matrículas.
                      </p>
                    </div>
                    <Switch
                      checked={deleteOnlyMode}
                      onCheckedChange={setDeleteOnlyMode}
                    />
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </div>
  );
}